module.exports = __webpack_public_path__ + "app/img/logoBG.391b4823.jpg";